export enum OrderByEnum {
  Asc = 'ASC',
  Desc = 'DESC',
}
